var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _path5, _path6, _path7, _path8, _rect5, _rect6, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArticles = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 350,
  height: 362,
  viewBox: "0 0 350 362",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 350,
  height: 110,
  rx: 8,
  fill: "white",
  fillOpacity: 0.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 16,
  width: 37,
  height: 36,
  rx: 4,
  fill: "black",
  fillOpacity: 0.1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M188 40C190.209 40 192 41.7909 192 44V56C192 58.2091 190.209 60 188 60H69C66.7909 60 65 58.2091 65 56V44C65 41.7909 66.7909 40 69 40H188Z",
  fill: "black",
  fillOpacity: 0.1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M294 16C296.209 16 298 17.7909 298 20V32C298 34.2091 296.209 36 294 36H69C66.7909 36 65 34.2091 65 32V20C65 17.7909 66.7909 16 69 16H294Z",
  fill: "black",
  fillOpacity: 0.1
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M224 64C226.209 64 228 65.7909 228 68V74C228 76.2091 226.209 78 224 78H69C66.7909 78 65 76.2091 65 74V68C65 65.7909 66.7909 64 69 64H224Z",
  fill: "black",
  fillOpacity: 0.1
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M315 80C317.209 80 319 81.7909 319 84V90C319 92.2091 317.209 94 315 94H69C66.7909 94 65 92.2091 65 90V84C65 81.7909 66.7909 80 69 80H315Z",
  fill: "black",
  fillOpacity: 0.1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  y: 126,
  width: 350,
  height: 110,
  rx: 8,
  fill: "white",
  fillOpacity: 0.5
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 142,
  width: 37,
  height: 36,
  rx: 4,
  fill: "black",
  fillOpacity: 0.1
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M188 166C190.209 166 192 167.791 192 170V182C192 184.209 190.209 186 188 186H69C66.7909 186 65 184.209 65 182V170C65 167.791 66.7909 166 69 166H188Z",
  fill: "black",
  fillOpacity: 0.1
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M294 142C296.209 142 298 143.791 298 146V158C298 160.209 296.209 162 294 162H69C66.7909 162 65 160.209 65 158V146C65 143.791 66.7909 142 69 142H294Z",
  fill: "black",
  fillOpacity: 0.1
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M224 190C226.209 190 228 191.791 228 194V200C228 202.209 226.209 204 224 204H69C66.7909 204 65 202.209 65 200V194C65 191.791 66.7909 190 69 190H224Z",
  fill: "black",
  fillOpacity: 0.1
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M315 206C317.209 206 319 207.791 319 210V216C319 218.209 317.209 220 315 220H69C66.7909 220 65 218.209 65 216V210C65 207.791 66.7909 206 69 206H315Z",
  fill: "black",
  fillOpacity: 0.1
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  y: 252,
  width: 350,
  height: 110,
  rx: 8,
  fill: "white",
  fillOpacity: 0.5
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 268,
  width: 37,
  height: 36,
  rx: 4,
  fill: "black",
  fillOpacity: 0.1
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M188 292C190.209 292 192 293.791 192 296V308C192 310.209 190.209 312 188 312H69C66.7909 312 65 310.209 65 308V296C65 293.791 66.7909 292 69 292H188Z",
  fill: "black",
  fillOpacity: 0.1
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M294 268C296.209 268 298 269.791 298 272V284C298 286.209 296.209 288 294 288H69C66.7909 288 65 286.209 65 284V272C65 269.791 66.7909 268 69 268H294Z",
  fill: "black",
  fillOpacity: 0.1
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M224 316C226.209 316 228 317.791 228 320V326C228 328.209 226.209 330 224 330H69C66.7909 330 65 328.209 65 326V320C65 317.791 66.7909 316 69 316H224Z",
  fill: "black",
  fillOpacity: 0.1
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M315 332C317.209 332 319 333.791 319 336V342C319 344.209 317.209 346 315 346H69C66.7909 346 65 344.209 65 342V336C65 333.791 66.7909 332 69 332H315Z",
  fill: "black",
  fillOpacity: 0.1
})));
export default SvgArticles;